import styled from 'styled-components';
import { cvBreakpoint768 } from '@carvana/theme';

export const DashedWrapper = styled.div`
  align-items: center;
  background-color: ${props => props.dragging ? 'lightgray' : ''};
  display: flex;
  flex: 1;
  flex-direction: column;

  @media (min-width: ${cvBreakpoint768}px) {
    border: dashed #D9DDE9 4px;
    border-radius: 4px;
    justify-content: center;
  }
`;

export const DropContainer = styled.div`
  position: absolute;
  top: 50%;
  right: 0;
  left: 0;
  text-align: center;
  color: grey;
  font-size: 3;
`;
